import { useDispatch, useSelector } from "react-redux";
import InputAHSF from "../../../../Components/InputAHSF";
import "./style.css";
import TextAreaAHSF from "../../../../Components/TextAreaAHSF";
import AllDropDownsAHSF from "../../../../Components/AllDropDownsAHSF";
import AttachmentASFH from "../../../../Components/AttachmentsAHSF";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import { useEffect, useState } from "react";
import {
  AddDetailsOfResearchSubmittedForAwardFiveYears,
  DetailsResearchSubmittedForAward,
  GetOneDetailsOfResearchSubmittedForAwardFiveYears,
  UpdateDetailsOfResearchSubmittedForAwardFiveYears,
} from "../../../../Redux/Reducers/Submitter/DetailsOfResearchSubmittedForAwardLastFiveYears";
import { GetAllC_ST_RA_ParticipationType } from "../../../../Redux/Reducers/Submitter/SC_ST_RA_ParticipationType";
import { GetAllPublic_ST_TimePeriod } from "../../../../Redux/Reducers/Shared/PublicTimePeriod";
import Swal from "sweetalert2";
import $ from "jquery";
import { setRefreshTable } from "../../../../Redux/Reducers/Shared/VariousVariables";
import { useParams } from "react-router-dom";
const AddEditeSummary = (props) => {
  const dispatch = useDispatch();
  const { ApplicationInformationId } = useParams();
  const lang = useSelector((state) => state.languageReducer.Language);
  const PublicTimePeriodList = useSelector(
    (state) => state.PublicTimePeriod.PublicTimePeriod
  );
  const SC_ST_RA_ParticipationTypeList = useSelector(
    (state) => state.SC_ST_RA_ParticipationType.SC_ST_RA_ParticipationTypeList
  );
  const [renderData, setRenderData] = useState(false);
  const [editValue, setEditValue] = useState(null);
  const [editText, setEditText] = useState(null);
  const [SummaryList, setSummaryList] = useState({
    detailsOfResearchSubmittedForAwardLastFiveYearsId:
      props.detailsOfResearchSubmittedForAwardLastFiveYearsId,
    researchSorting: null,
    referenceAPACitation: null,
    numberOfCitations: null,
    file: null,
    participationTypeId: null,
    yearOfPublication_TimePeriodId: null,
    timePeriodNumber: null,
    researchRelevance: null,
    attachedResearchPaper: null,
  });

  const getData = async () => {
    if (props.FormStatus == "Edit") {
      const data = await dispatch(
        GetOneDetailsOfResearchSubmittedForAwardFiveYears({
          detailsOfResearchSubmittedForAwardLastFiveYearsId:
            props.detailsOfResearchSubmittedForAwardLastFiveYearsId,
        })
      );
      console.log(data.payload, "uuiu");
      if (data.payload) {
        setSummaryList({
          detailsOfResearchSubmittedForAwardLastFiveYearsId:
            props.detailsOfResearchSubmittedForAwardLastFiveYearsId,
          researchSorting: data.payload?.researchSorting,
          referenceAPACitation: data.payload?.referenceAPACitation,
          numberOfCitations: data.payload?.numberOfCitations,
          file: null,
          participationTypeId: data.payload?.participationTypeId,
          yearOfPublication_TimePeriodId:
            data.payload?.yearOfPublication_TimePeriodId,
          timePeriodNumber: data.payload?.timePeriodNumber,
          researchRelevance: data.payload?.researchRelevance,
          attachedResearchPaper: data.payload?.attachedResearchPaper,
        });
      }
      setRenderData(true);
    }
  };

  useEffect(() => {
    getData();
    dispatch(GetAllC_ST_RA_ParticipationType({ isEn: lang !== "ar" }));
    dispatch(
      GetAllPublic_ST_TimePeriod({
        academicAchievementShow: false,
        workExperiencePeriodFromYearShow: false,
        workExperiencePeriodToYearShow: false,
        volunteerCommunityWorkPeriodToYearShow: false,
        volunteerCommunityWorkPeriodFromYearShow: false,
        detailsOfResearchSubmittedForAwardLastFiveYearsShow: true,
      })
    );
  }, []);
  const [errors, setErrors] = useState({});

  const ValidationFunction = () => {
    const newErrors = {};
    if (!SummaryList?.numberOfCitations) {
      newErrors.numberOfCitations = true;
    }

    if (!SummaryList?.referenceAPACitation) {
      newErrors.referenceAPACitation = true;
    }

    if (!SummaryList?.numberOfCitations) {
      newErrors.numberOfCitations = true;
    }

    if (!SummaryList?.participationTypeId) {
      newErrors.participationTypeId = true;
    }

    if (!SummaryList?.yearOfPublication_TimePeriodId) {
      newErrors.yearOfPublication_TimePeriodId = true;
    }
    if (!SummaryList?.researchRelevance) {
      newErrors.researchRelevance = true;
    }
    // if (!SummaryList?.attachedResearchPaper) {
    //   newErrors.attachedResearchPaper = true;
    // }

    // (SummaryList?.file?.name==null)||(SummaryList?.attachedResearchPaper==null)
    if (SummaryList?.attachedResearchPaper == null && !SummaryList?.file) {
      newErrors.file = true;
    }
    return newErrors;
  };

  const AddSummary = async () => {
    const newErrors = ValidationFunction();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let FormDataSummary = new FormData();
      FormDataSummary.append(
        "NumberOfCitations",
        SummaryList?.numberOfCitations
      );

      FormDataSummary.append(
        "ReferenceAPACitation",
        SummaryList?.referenceAPACitation
      );
      FormDataSummary.append(
        "NumberOfCitations",
        SummaryList?.numberOfCitations
      );
      FormDataSummary.append(
        "ParticipationTypeId",
        SummaryList?.participationTypeId
      );
      FormDataSummary.append(
        "YearOfPublication_TimePeriodId",
        SummaryList?.yearOfPublication_TimePeriodId
      );
      FormDataSummary.append(
        "ResearchRelevance",
        SummaryList?.researchRelevance
      );
      FormDataSummary.append(
        "AttachedResearchPaper",
        SummaryList?.attachedResearchPaper
      );
      FormDataSummary.append("file", SummaryList?.file);
      FormDataSummary.append(
        "ApplicationInformationId",
        localStorage.getItem("ApplicationInformationId") ||
          ApplicationInformationId
      );
      const add = await dispatch(
        AddDetailsOfResearchSubmittedForAwardFiveYears(FormDataSummary)
      );

      if (add.payload.code == 200) {
        dispatch(
          DetailsResearchSubmittedForAward({
            applicationInformationId:
              localStorage.getItem("ApplicationInformationId") ||
              ApplicationInformationId,
          })
        );
        Swal.fire({
          position: "center",
          icon: "success",
          title: lang != "en" ? "تم حفظ المعلومات بنجاح" : "Saved Successfully",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
        dispatch(setRefreshTable({ tableId: "DetailsOfResearchSubmitted" }));
        $(".close-btn").trigger("click");
      }
    }
  };

  const EditSummary = async () => {
    const newErrors = ValidationFunction();
    setErrors(newErrors);
    if (Object.keys(newErrors).length === 0) {
      let FormDataSummary = new FormData();
      FormDataSummary.append("ResearchSorting", SummaryList?.researchSorting);
      FormDataSummary.append(
        "ReferenceAPACitation",
        SummaryList?.referenceAPACitation
      );
      FormDataSummary.append(
        "NumberOfCitations",
        SummaryList?.numberOfCitations
      );
      FormDataSummary.append(
        "DetailsOfResearchSubmittedForAwardLastFiveYearsId",
        props.detailsOfResearchSubmittedForAwardLastFiveYearsId
      );
      FormDataSummary.append(
        "ParticipationTypeId",
        SummaryList?.participationTypeId
      );
      FormDataSummary.append(
        "YearOfPublication_TimePeriodId",
        SummaryList?.yearOfPublication_TimePeriodId
      );
      FormDataSummary.append(
        "ResearchRelevance",
        SummaryList?.researchRelevance
      );
      FormDataSummary.append(
        "AttachedResearchPaper",
        SummaryList?.attachedResearchPaper
      );
      FormDataSummary.append("file", SummaryList?.file);
      FormDataSummary.append(
        "ApplicationInformationId",
        localStorage.getItem("ApplicationInformationId") ||
          ApplicationInformationId
      );
      const update = await dispatch(
        UpdateDetailsOfResearchSubmittedForAwardFiveYears(FormDataSummary)
      );

      if (update.payload.code == 200) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: lang != "en" ? "تم حفظ المعلومات بنجاح" : "Saved Successfully",
          showConfirmButton: false,
          timer: 1500,
          // width: "500px",
        });
        dispatch(setRefreshTable({ tableId: "DetailsOfResearchSubmitted" }));
        $(".close-btn").trigger("click");
      }
    }
  };
  console.log(SummaryList, "SummaryList");

  const HTML = (
    <>
      <div className="form-grid-custom-practicalExperiences">
        <div>
          <TextAreaAHSF
            fieldsName="APACitation"
            show={true}
            lang={lang}
            disabled={props.disabled}
            onChange={(e) => {
              setSummaryList({
                ...SummaryList,
                referenceAPACitation: e.target.value,
              });
            }}
            defaultValue={SummaryList?.referenceAPACitation}
            showValidationMessage={errors?.referenceAPACitation}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
        <div>
          <InputAHSF
            fieldsName="NumberOfTimesTheSearch"
            show={true}
            type="number"
            lang={lang}
            disabled={props.disabled}
            onChange={(e) => {
              setSummaryList({
                ...SummaryList,
                numberOfCitations: e.target.value,
              });
            }}
            value={SummaryList?.numberOfCitations}
            showValidationMessage={errors?.numberOfCitations}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
        <div>
          <AllDropDownsAHSF
            fieldsName="ParticipationType"
            lang={lang}
            show={true}
            yesNo={true}
            disabled={props.disabled}
            arrayOoptionList={SC_ST_RA_ParticipationTypeList}
            KeyText={
              lang !== "ar"
                ? "participationTypeNameEn"
                : "participationTypeNameAr"
            }
            KeyValue={"participationTypeId"}
            value={SummaryList?.participationTypeId}
            valueEdite={SummaryList?.participationTypeId}
            submissionStatus={"edite"}
            textEdite={
              lang !== "ar"
                ? SummaryList?.participationTypeNameEn
                : SummaryList?.participationTypeNameAr
            }
            id={"participationTypeId"}
            dropdownType={"search"}
            defaultValue={SummaryList?.participationTypeId}
            OnClickLi={(e) => {
              setSummaryList({
                ...SummaryList,
                participationTypeId: e.participationTypeId,
              });
              setEditValue(e.participationTypeId);
              setEditText(
                lang !== "ar"
                  ? "participationTypeNameAr"
                  : "participationTypeNameEn"
              );
            }}
            showValidationMessage={errors?.participationTypeId}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
        <div>
          <AllDropDownsAHSF
            dropdownPlacement="top"
            disabled={props.disabled}
            key={lang}
            fieldsName="YearPublication"
            hidelable={false}
            lang={lang}
            show={true}
            valueEdite={SummaryList?.timePeriodNumber}
            submissionStatus={"edite"}
            textEdite={SummaryList?.timePeriodNumber}
            arrayOoptionList={PublicTimePeriodList}
            KeyText={lang !== "ar" ? "timePeriodNumber" : "timePeriodNumber"}
            id={"yearOfPublication_TimePeriodId"}
            dropdownType={"search"}
            defaultValue={SummaryList?.yearOfPublication_TimePeriodId}
            value={SummaryList?.yearOfPublication_TimePeriodId}
            OnClickLi={(e) => {
              console.log(e, "eeeeeeeeeeee");

              setSummaryList({
                ...SummaryList,
                yearOfPublication_TimePeriodId: e.timePeriodId,
              });
              setEditValue(e.timePeriodNumber);
              setEditText(
                lang !== "ar" ? "timePeriodNumber" : "timePeriodNumber"
              );
            }}
            showValidationMessage={errors?.yearOfPublication_TimePeriodId}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
          {/* <AllDropDownsAHSF
            fieldsName="YearPublication"
            lang={lang}
            show={true}
            yesNo={true}
            dropdownType="normal"
            disabled={props.disabled}
            arrayOoptionList={PublicTimePeriodList}
            KeyText={lang !== "ar" ? "timePeriodNumber" : "timePeriodNumber"}
            KeyValue={"timePeriodId"}
            value={SummaryList?.yearOfPublication_TimePeriodId}
            onChange={(e) => {
              setSummaryList({
                ...SummaryList,
                yearOfPublication_TimePeriodId: e.target.value,
              });
            }}
            showValidationMessage={errors?.yearOfPublication_TimePeriodId}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          /> */}
        </div>

        <div style={{ marginTop: "8px" }}>
          <AttachmentASFH
            fieldsName={"ResearchpaperAttached"}
            show={true}
            disabled={props.disabled}
            clear={false}
            readOnly={false}
            id={`fileSu1`}
            lang={lang}
            AttachementType="ResearchPaper"
            singleFile={SummaryList?.attachedResearchPaper}
            onChange={(e) => {
              setSummaryList({
                ...SummaryList,
                file: e.target.files[0],
              });
            }}
            showValidationMessage={errors?.file}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
        <div>
          <TextAreaAHSF
            fieldsName="RelevanceResearchTopic"
            show={true}
            lang={lang}
            disabled={props.disabled}
            onChange={(e) => {
              setSummaryList({
                ...SummaryList,
                researchRelevance: e.target.value,
              });
            }}
            defaultValue={SummaryList?.researchRelevance}
            showValidationMessage={errors?.researchRelevance}
            validationMessage={lang == "ar" ? "حقل اجباري" : "Field Required"}
          />
        </div>
        {!props.disabled ? (
          <div className="containerButtonsMAinSubmission">
            <ButtonAHSF
              type={"submitter"}
              fieldsName={`${
                props.FormStatus == "Edit" ? "EditButton" : "AddButton"
              }`}
              lang={lang}
              onClick={() => {
                if (props.FormStatus == "Edit") {
                  EditSummary();
                }
                if (props.FormStatus == "Add") {
                  AddSummary();
                }
              }}
              disabled={false}
              // title={"التالي"}
              // text={"التالي"}
              show={true}
            />
          </div>
        ) : (
          ""
        )}
      </div>
    </>
  );
  if (props.FormStatus == "Edit") {
    if (SummaryList && renderData) {
      return <>{HTML}</>;
    }
  } else if (props.FormStatus == "Add") {
    return <>{HTML}</>;
  }
};

export default AddEditeSummary;
